import { z } from 'zod'
import { DAY_IN_SECONDS, HOUR_IN_SECONDS, WEEK_IN_SECONDS } from './units'

export const granularityOptions = ['1hour', '1day', '1week'] as const
export const granularity = z.enum(granularityOptions)
export type Granularity = z.infer<typeof granularity>

export const granularityInSeconds = {
  '1hour': HOUR_IN_SECONDS,
  '1day': DAY_IN_SECONDS,
  '1week': WEEK_IN_SECONDS,
} satisfies Record<Granularity, number>
